// components/Tables/PaymentsTable.js
import React from 'react';

const PaymentsTable = ({ data = [] }) => {
  return (
    <div className="table-responsive">
      <table className="table table-history mb-0">
        <thead>
          <tr>
            <th>Дата</th>
            <th>Сума</th>
            <th>Спосіб оплати</th>
            <th>Статус</th>
          </tr>
        </thead>
        <tbody>
          {data.map((payment, index) => (
            <tr key={index}>
              <td>{new Date(payment.date).toLocaleDateString('uk-UA')}</td>
              <td>{payment.amount} грн.</td>
              <td>{payment.method}</td>
              <td>{payment.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentsTable;